import React, { Component } from "react";
import { ThemeContext } from "..";
// const carouselContainer = document.querySelector(".carousel-container");

const carouselSlidesData = [
  {
    projectName: "UBEREE Online marketplace for local services",
    author: "Backend developer",
    source: "Node.js,Typeorm, Postgresql, Redis, Flutter, AWS, github",
    responce: "Developed Api's for the entire project",
  },
  {
    projectName: "Malaysian Government Asset Management System",
    author: "Freelance front end developer",
    source:
      "React.js , Next.js , Apollo (Graphql) , Graphql , Node.js, GRPC , Postgres , Mongodb , Docker , Keycloak ",
    responce:
      "I'm Developed a Web Pages & Api integrated for the project also working on Bug fixing in front end and back end",
  },
  {
    projectName: "Vulnerability scanning web app",
    author:
      "The main goal of the app is detecting Vulnerability from the Customer AWS ec2 instance and have a lot of tools to testing websites ex: extracting website subdomains, scanning open port of app etc",
    source:
      "Nodejs,Typeorm, MySQL, Reactjs, Redux.js, Typescript, python,Flask",
    responce: "Full stack developer I'm currently developing this project",
  },
  {
    projectName: "SAFWA E-tender System",
    author: "Freelance front end developer / UI/UX developer",
    source:
      "React.js , Next.js , Apollo (Graphql) , Graphql , Node.js, GRPC , Postgres , Mongodb , Docker , Keycloak ",
    responce:
      "I'm Developed a Web Pages & Api integrated for the project also working on Bug fixing in front end",
  },

  {
    projectName: "Bidtoaster",
    author: `Bidtoaster Digital Procurement Platform Coordinates procurement
    activities between buyer and supplier organizations, driving consistency
    and quality`,
    source: `Flask, MongoDB, Python, React.js`,
    responce: `full stack developer
The partially developed the project, developing missed features and bug
fixing`,
  },
  {
    projectName: "Ztractor",
    author: "Frontend developer",
    source: "React.js, Redux.js, Bing Maps, Sass",
    responce:
      "Ztractor The World's First Autonomous Electric Tractor, I'm developed web pages and lot functionality implemented  using bingmaps ",
  },
  {
    projectName: "HueTouch",
    author: `HUE Touch allows you to write your estimates at the vehicle,
    automatically syncing to your desktop and mobile devices`,
    source: `Nodejs,PostgreSQL , Vue.js`,
    responce: `Backend Developer
    Developed API's.`,
  },
  {
    projectName: `Practo like App`,
    author: `Backend developer`,
    source: `Node.js, Mysql, ionic`,
    responce: `developed API's for community module (social media) and Bug fixing`,
  },

  {
    projectName: "Worked on lot Project...",
    author: "Hire me..",
    source: "I can work on Any Stack, Any Programming language",
  },
];

export class RecentWork extends Component {
  constructor(props) {
    super(props);

    this.goToSlide = this.goToSlide.bind(this);
    this.goToPrevSlide = this.goToPrevSlide.bind(this);
    this.goToNextSlide = this.goToNextSlide.bind(this);

    this.state = {
      activeIndex: 0,
    };
  }

  goToSlide(index) {
    this.setState({
      activeIndex: index,
    });
  }

  goToPrevSlide(e) {
    e.preventDefault();

    let index = this.state.activeIndex;
    let slides = carouselSlidesData;
    let slidesLength = slides.length;

    if (index < 1) {
      index = slidesLength;
    }

    --index;

    this.setState({
      activeIndex: index,
    });
  }

  goToNextSlide(e) {
    e.preventDefault();

    let index = this.state.activeIndex;
    let slides = carouselSlidesData;
    let slidesLength = slides.length - 1;

    if (index === slidesLength) {
      index = -1;
    }

    ++index;

    this.setState({
      activeIndex: index,
    });
  }

  render() {
    return (
      <ThemeContext.Consumer>
        {(darkMode) => (
          <div style={{ background: darkMode ? "black" : "white" }}>
            <div className="carousel">
              <center
                className="title"
                style={{ color: darkMode ? "white" : "black", fontSize: 25 }}
              >
                MY RECENT WORK
              </center>
              <CarouselLeftArrow onClick={(e) => this.goToPrevSlide(e)} />

              <ul className="carousel__slides">
                {carouselSlidesData.map((slide, index) => (
                  <CarouselSlide
                    key={index}
                    index={index}
                    activeIndex={this.state.activeIndex}
                    slide={slide}
                    darkMode={darkMode}
                  />
                ))}
              </ul>

              <CarouselRightArrow onClick={(e) => this.goToNextSlide(e)} />

              <ul className="carousel__indicators">
                {carouselSlidesData.map((slide, index) => (
                  <CarouselIndicator
                    key={index}
                    index={index}
                    activeIndex={this.state.activeIndex}
                    isActive={this.state.activeIndex == index}
                    onClick={(e) => this.goToSlide(index)}
                  />
                ))}
              </ul>
            </div>
          </div>
        )}
      </ThemeContext.Consumer>
    );
  }
}

class CarouselLeftArrow extends Component {
  render() {
    return (
      <a
        href="#"
        className="carousel__arrow carousel__arrow--left"
        onClick={this.props.onClick}
      >
        <span style={{ fontSize: "35px" }}>{`<`}</span>
      </a>
    );
  }
}

class CarouselRightArrow extends Component {
  render() {
    return (
      <a
        href="#"
        className="carousel__arrow carousel__arrow--right"
        onClick={this.props.onClick}
      >
        <span style={{ fontSize: "35px" }}>{`>`}</span>
      </a>
    );
  }
}

class CarouselIndicator extends Component {
  render() {
    return (
      <li style={{ marginTop: 20 }}>
        <a
          className={
            this.props.index == this.props.activeIndex
              ? "carousel__indicator carousel__indicator--active"
              : "carousel__indicator"
          }
          onClick={this.props.onClick}
        />
      </li>
    );
  }
}

class CarouselSlide extends Component {
  render() {
    const { darkMode } = this.props;
    return (
      <li
        className={
          this.props.index == this.props.activeIndex
            ? "carousel__slide carousel__slide--active"
            : "carousel__slide"
        }
      >
        <h2 style={{ color: darkMode ? "white" : "black" }}>
          {this.props.slide.projectName}
        </h2>

        <p>
          <small>{this.props.slide.author}</small>
        </p>
        <p>{this.props.slide.responce}</p>
        <small className="carousel-slide__source">
          <strong>Tech Stack :</strong> {this.props.slide.source}
        </small>
      </li>
    );
  }
}
